import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardContent, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { Delete, NotificationsActive } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { deleteReminder, getUpcomingReminders } from '../../../services/reminderService';

const UpcomingReminders = () => {
  const [reminders, setReminders] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const navigate = useNavigate();

  const fetchReminders = async () => {
    try {
      const response = await getUpcomingReminders();
      setReminders(response?.data?.data || []);
    } catch (error) {
      // The dashboard must still render if this one call fails.
      setReminders([]);
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => {
    fetchReminders();
  }, []);

  const handleDelete = async (event, reminderId) => {
    event.stopPropagation();
    try {
      const response = await deleteReminder(reminderId);
      toast.success(response?.data?.message);
      await fetchReminders();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Could not delete the reminder');
    }
  };

  // Nothing to show and nothing pending: stay out of the way rather than showing an empty card.
  if (loaded && !reminders.length) return null;

  return (
    <Card>
      <CardHeader title="Upcoming reminders" />
      <CardContent sx={{ pt: 1 }}>
        <Stack spacing={1}>
          {reminders.map((reminder) => (
            <Stack
              key={reminder.id}
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{ cursor: 'pointer' }}
              onClick={() =>
                reminder.task?.projectId &&
                navigate(`/project/board/${reminder.task.projectId}?task=${reminder.task.id}`)
              }
            >
              <NotificationsActive fontSize="small" sx={{ color: '#f0a500' }} />
              <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
                <Typography variant="body2" noWrap title={reminder.note}>
                  {reminder.note}
                </Typography>
                <Typography variant="caption" sx={{ color: 'text.secondary' }} noWrap>
                  {dayjs(reminder.remindAt).format('ddd DD MMM, HH:mm')}
                  {reminder.task?.taskName ? ` · ${reminder.task.taskName}` : ''}
                </Typography>
              </Stack>
              <Tooltip title="Delete reminder" placement="top" arrow>
                <IconButton size="small" onClick={(event) => handleDelete(event, reminder.id)}>
                  <Delete fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default UpcomingReminders;
